export default __webpack_public_path__ + "static/media/problema-10.c30ece2f.webp";